<template>
    <oss-dialog
        v-model="value"
        :title="title"
        :validTitle="validTitle"
        :hideNext="true"
        :previousDisabled="true"
        @valid="valid"
        @close="close"
        width="800px"
    >
        <h4>{{ description }}</h4>
    </oss-dialog>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["valid", "close"],
})
export class ossDialogNotification extends Vue {
    @Prop() value: boolean;
    @Prop({ default: "Titre" }) title: string;
    @Prop({ default: "" }) description: string;
    @Prop({ default: "Valider" }) validTitle: string;

    valid() {
        this.$emit("valid");
    }

    close() {
        this.$emit("close");
    }
}

export default toNative(ossDialogNotification);
</script>

<style></style>
